export function milliToSecond(data: number): number {
  return Math.round(data / 1000);
}
